module.exports = __webpack_public_path__ + "static/media/ar-branded-banner-bg.391b6182.png";